import React from "react";
import call from "../../assets/call.png";
import GetInTouch from "../Home/GetInTouch/GetInTouch";

const TermsOfUse = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Website Terms <span class="gray-text-color">of Use</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section legal">
        <div class="container">
          <div>
            <div class="leagl-wrapper">
              <div
                data-w-id="eb6b77d4-5c7b-d30c-b6da-7c7144717a91"
                class="legal-wrapper"
              >
                <p>Effective Date: 17 Oct 2024 </p>
                <div class="margin-30px">
                  <p class="terms-paragraph">
                    This website (the “Site”) is operated by
                    <strong>
                      ORE Migration Services PTY Ltd T/A Win Migration Group
                    </strong>
                    (ABN 11 640 885 623) (“we,” “our,” or “us”). By using and
                    accessing the Site, you agree to comply with these terms of
                    use (the “Terms”). If you do not agree to these Terms, you
                    must immediately cease using the Site.
                  </p>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>1. Information and Availability</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      The information and materials available on our Site (the
                      “Content”) are provided for general information purposes
                      only and should not be relied upon as professional advice.
                      The Content does not take into account your individual
                      circumstances, needs, or objectives and does not
                      constitute legal, financial, or migration advice. Before
                      acting on any information found on our Site, we strongly
                      recommend that you seek your own legal or professional
                      advice tailored to your specific situation.
                    </p>
                    <p class="terms-paragraph">
                      We strive to ensure that the information presented on the
                      Site is accurate and up-to-date, but we make no warranties
                      or representations regarding the accuracy, completeness,
                      or reliability of the Content, and we disclaim liability
                      for any errors or omissions to the fullest extent
                      permitted by law. The Content is subject to change without
                      notice, and we do not guarantee the continuous
                      availability of the Site.
                    </p>
                    <p class="terms-paragraph">
                      Please note that receiving any information from us,
                      including downloading resources from our Site, does not
                      establish a solicitor-client or migration agent-client
                      relationship between you and{" "}
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group.
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>2. Intellectual Property Rights</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      All intellectual property on the Site, including but not
                      limited to text, images, logos, designs, trademarks, and
                      domain names (collectively, “Our Intellectual Property”),
                      is owned or licensed by
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group.
                      </strong>
                    </p>
                    <p class="terms-paragraph">
                      We grant you a limited, non-exclusive, revocable license
                      to access and use the Site solely for personal,
                      non-commercial purposes. You may display, print, and
                      download portions of the Content to your personal device,
                      provided that you do not remove or alter any copyright or
                      proprietary notices.
                    </p>
                    <p class="terms-paragraph">
                      You must not use the Site or the Content for any
                      commercial or revenue-generating activities. This
                      includes, but is not limited to, advertising your own
                      services, generating revenue, or engaging in activities
                      that compete with our business.
                    </p>
                    <p class="terms-paragraph">
                      Except as permitted by these Terms or otherwise authorized
                      by us in writing, you agree not to:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Copy, reproduce, modify, distribute, or republish Our
                        Intellectual Property;
                      </li>
                      <li class="terms-list-item">
                        Use Our Intellectual Property for any commercial
                        purposes or to advertise your own business;
                      </li>
                      <li class="terms-list-item">
                        Create derivative works based on Our Intellectual
                        Property, or frame or embed any part of the Site into
                        another website or platform.
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>3. Conduct We Do Not Accept</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      You agree not to engage in conduct that is illegal,
                      inappropriate, or harmful when using our Site. This
                      includes but is not limited to the following:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Violating the privacy or legal rights of others;
                      </li>
                      <li class="terms-list-item">
                        Using the Site to harass, defame, threaten, or offend
                        any individual or entity;
                      </li>
                      <li class="terms-list-item">
                        Using the Site for unlawful purposes;
                      </li>
                      <li class="terms-list-item">
                        Interfering with the proper functioning of the Site or
                        tampering with its security features;
                      </li>
                      <li class="terms-list-item">
                        Transmitting harmful software, such as viruses or Trojan
                        horses, that could damage or disrupt the Site;
                      </li>
                      <li class="terms-list-item">
                        Engaging in unsolicited electronic communications (e.g.,
                        spamming);
                      </li>
                      <li class="terms-list-item">
                        Using automated tools (e.g., data mining, robots, screen
                        scraping) to collect data from the Site;
                      </li>
                      <li class="terms-list-item">
                        Assisting or enabling third parties to engage in any of
                        the above activities
                      </li>
                    </ul>
                    <p>
                      We reserve the right to terminate or restrict your access
                      to the Site if you violate these Terms or engage in any
                      prohibited conduct.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>4. Limitation of Liability</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      To the fullest extent permitted by law,{" "}
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group
                      </strong>{" "}
                      and its affiliates, directors, employees, and agents will
                      not be liable for any loss or damage, including but not
                      limited to direct, indirect, incidental, or consequential
                      damages, arising from your use of, or inability to use,
                      the Site or any Content provided on the Site.
                    </p>

                    <p>
                      Your use of the Site and any reliance on its Content is at
                      your own risk. We are not responsible for any errors,
                      omissions, or inaccuracies in the information provided on
                      the Site.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>4. Limitation of Liability</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      To the fullest extent permitted by law,{" "}
                      <strong>
                        ORE Migration Services PTY Ltd T/A Win Migration Group
                      </strong>{" "}
                      and its affiliates, directors, employees, and agents will
                      not be liable for any loss or damage, including but not
                      limited to direct, indirect, incidental, or consequential
                      damages, arising from your use of, or inability to use,
                      the Site or any Content provided on the Site.
                    </p>

                    <p>
                      Your use of the Site and any reliance on its Content is at
                      your own risk. We are not responsible for any errors,
                      omissions, or inaccuracies in the information provided on
                      the Site.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>5. Third-Party Links</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      Our Site may contain links to third-party websites or
                      services that are not owned or controlled by us. These
                      links are provided for your convenience and do not imply
                      any endorsement of the linked websites or their content.
                      We are not responsible for the content, privacy practices,
                      or any activities of these third-party sites. You access
                      these sites at your own risk and should review their
                      respective terms and privacy policies.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>6. Privacy</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      Your use of the Site is also governed by our Privacy
                      Policy, which explains how we collect, use, and protect
                      your personal information. By using the Site, you consent
                      to the collection and use of your information as outlined
                      in our Privacy Policy.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>7. Changes to the Terms of Use</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We may amend or modify these Terms at any time, and such
                      changes will take effect upon posting to the Site. Your
                      continued use of the Site after any changes have been made
                      constitutes acceptance of the updated Terms. We encourage
                      you to regularly review these Terms to stay informed of
                      any updates.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>8. Termination</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We reserve the right to terminate or suspend your access
                      to the Site at our discretion, without notice, if you
                      violate these Terms or engage in any activity that we
                      consider harmful or inappropriate.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong>9. Governing Law</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      These Terms are governed by the laws of Victoria,
                      Australia. Any disputes arising from the use of the Site
                      or these Terms will be subject to the exclusive
                      jurisdiction of the courts of Victoria, Australia.
                    </p>
                  </div>
                </div>

                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      ORE Migration Services PTY Ltd T/A Win Migration Group ABN
                      11 640 885 623
                    </p>
                    <p>
                      Email:
                      <a href="mailto:contact@winmigrationgroup.com">
                        contact@winmigrationgroup.com
                      </a>
                    </p>
                    <p>Last updated: 17 Oct 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default TermsOfUse;
